module.exports = __webpack_public_path__ + "img/dog-confirm.9df73d4a.png";